@import 'src/client/view/style/constants.scss';

.stageStatus {
  margin-top: 3vh;
  min-height: 5vh;
  font-size: 5vh;
  line-height: 5vh;
  text-align: center;
}
